import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/config';
import { DatosCompradorProvider} from './context/Context.js';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <DatosCompradorProvider>
        <App />
    </DatosCompradorProvider>
);

reportWebVitals();
